/*
 * NavPoints (Versiyon B - viewport ortasına göre aktif)
 * https://github.com/Ins-V/navpoints
 *
 * Author: Vitaliy Gusarev
 *
 * Licensed under the MIT license.
 */
;(function($) {
	var settings = {
		speed: 600,
		offset: 0,
		currentClass: 'active',
		updateHash: false,
		classToParent: false
	}

	var NavPoints = {
		init: function(options, navbar) {
			settings = $.extend(settings, options);
			this.$navbar = $(navbar);
			this.$items = this.$navbar.find('a:not(.externals)');
			this.$window = $(window);
			this.hashNow = undefined;

			this.$items.on('click', this.clicked);
			this.$window.on('scroll', $.proxy(this.scrollPage, this));
			this.$window.on('resize', $.proxy(this.scrollPage, this));
		},
		clicked: function(e) {
			e.preventDefault();
			var hash = $(this).attr('href');
			var position = $(hash).offset().top - settings.offset;
			$('html, body').animate({
				scrollTop: position
			}, settings.speed);
		},
		scrollPage: function() {
			var self = this,
				sections = [],
				result;

			var windowTop = self.$window.scrollTop();
			var scrollMiddle = windowTop + (self.$window.height() / 2);

			self.$items.each(function() {
				var hash = $(this).attr('href');
				var section = $(hash);
				if (section.length) sections.push(section);
			});

			for (var i = 0; i < sections.length; i++) {
				var section = sections[i],
					sectionTop = section.offset().top - settings.offset,
					sectionBottom = sectionTop + section.outerHeight();

				if (scrollMiddle >= sectionTop && scrollMiddle < sectionBottom) {
					result = section.attr('id');
					break;
				}
			}

			if (result) {
				if (settings.updateHash) {
					var hash = '#' + result;
					if (self.hashNow != hash) {
						self.hashNow = hash;
						history.pushState({}, '', hash);
					}
				}

				if (settings.classToParent) {
					self.$items.parent().removeClass(settings.currentClass);
					$('a[href="#' + result + '"]').parent().addClass(settings.currentClass);
				} else {
					self.$items.removeClass(settings.currentClass);
					$('a[href="#' + result + '"]').addClass(settings.currentClass);
				}
			}
		}
	}

	$.fn.navpoints = function(options) {
		this.each(function() {
			var navpoints = Object.create(NavPoints);
			navpoints.init(options, this);
		});
	}
})(jQuery);